import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const BlockContent = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => (
    <div {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child) => renderChild(child))}
    </div>
  )
);

const config = createIntegratedAtom({
  displayName: 'Block Content',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
          paddingTop: px(20),
          paddingBottom: px(20),
          paddingRight: px(20),
          paddingLeft: px(20),
          borderBottomStyle: 'solid',
          borderBottomWidth: px(1),
          borderBottomColor: createRgbaColor('e6e6e6'),
          borderRightStyle: 'solid',
          borderRightWidth: px(1),
          borderRightColor: createRgbaColor('e6e6e6'),
          borderLeftStyle: 'solid',
          borderLeftWidth: px(1),
          borderLeftColor: createRgbaColor('e6e6e6'),
          backgroundColor: createRgbaColor('fff'),
        },
      },
    },
  },
  render: BlockContent,
  fields: {children: TListOfElement},
});

export default config;
